import { render, staticRenderFns } from "./TrolleyWithProductImages.vue?vue&type=template&id=56f3d554&scoped=true"
import script from "./TrolleyWithProductImages.vue?vue&type=script&lang=js"
export * from "./TrolleyWithProductImages.vue?vue&type=script&lang=js"
import style0 from "./TrolleyWithProductImages.vue?vue&type=style&index=0&id=56f3d554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3d554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
